// Module Import
//---------------------------------
import React, { useRef } from 'react'
import styled from 'styled-components'
import ReCAPTCHA from 'react-google-recaptcha'
import Field from '../../atoms/fields/field'
import TypographyAtom from '../../atoms/typography/typography'
import 'react-datepicker/dist/react-datepicker.css'
import ValidationWrapper from '../../atoms/fields/ValidationWrapper'
import { secondaryFont } from '../../../assets/consts/fonts'
import { brandError, brandIvory } from '../../../assets/consts/color'
import ButtonAtom from '../../atoms/buttons/buttons'

// Component Import
//---------------------------------

const Container = styled.div`
  padding: 20px;
  background-color: ${brandIvory};

  margin-bottom: 64px;

  @media only screen and (min-width: 48em) {
    padding: 40px 48px;
  }
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
`

const BodyWrapper = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: space-between;

  span,
  label {
    font-family: ${secondaryFont};
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 120%;
  }
`

const CommonInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  & > div:first-child {
    div {
      height: 100%;
    }

    input {
      height: 100%;
    }
  }

  @media only screen and (min-width: 1460px) {
    /* flex-direction: row;
    justify-content: space-between; */

    /* gap: 32px; */
  }
`

const SubmitWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  gap: 20px;

  @media only screen and (min-width: 48em) {
    /* flex-direction: row; */
  }

  @media only screen and (min-width: 64em) and (max-width: 1140px) {
    flex-direction: column;

    gap: 20px;
  }
`

const SubmitButtonWrapper = styled.div`
  button {
    /* width: 250px;
    height: 100%; */
    /* justify-content: center; */
    /* padding: 11px 16px; */
  }
`

const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 24px;

  /* &:last-child {
    width: 250px;
    flex-grow: 0;
  } */

  & > div {
    flex: 1;
  }

  @media only screen and (min-width: 48em) and (max-width: 1450px) {
    width: 100% !important;
  }
`

const FieldItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;

  position: relative;
  //max-width: 255px;

  & > div:first-child:not(.input-wrapper) {
    width: 100%;
  }

  .input-wrapper {
    width: 100%;

    &.checkbox {
      display: flex;
      flex-direction: row;
      gap: 10px;

      input {
        width: fit-content;
        order: 0;
      }

      label {
        order: 1;
      }
    }

    label {
      position: relative;
    }

    label[aria-required='true']::after {
      position: absolute;
      top: 0;
      right: -10px;
      content: '*';
      color: ${brandError};
    }

    .error {
      font-size: 16px;
      color: ${brandError};
    }
  }
`

// Component Export
//---------------------------------
export default function NotifyForm({ onSubmit, formValues, loading, onChange, errors }) {
  const recaptcha = useRef(null)
  const onSubmitFunc = (e) => {
    e.preventDefault()

    onSubmit(recaptcha.current.getValue(), recaptcha?.current)

    recaptcha?.current.reset()
  }

  const { email, checkbox } = formValues

  return (
    <Container>
      <div className="margin-24">
        <TypographyAtom
          type="P"
          weight="Regular"
          copy="This product is out of stock but we can notify you as soon as it’s available again. Simply leave us your email and we will take care of the rest."
        />
      </div>
      <Form id="notifyForm" onSubmit={onSubmitFunc}>
        <BodyWrapper>
          <CommonInputWrapper>
            <FieldWrapper>
              <FieldItem>
                <ValidationWrapper errorMessage={errors.email}>
                  <Field
                    labelText="Email Address"
                    placeholderText="Your email address"
                    fieldType="email"
                    labelFor="emailNotify"
                    fieldId="emailNotify"
                    fieldName="email"
                    value={email}
                    fullWidth
                    onChange={onChange}
                  />
                </ValidationWrapper>
              </FieldItem>
            </FieldWrapper>
            <FieldWrapper>
              <FieldItem>
                <ValidationWrapper errorMessage={errors.checkbox}>
                  <Field
                    labelText="Check this box to receive similar email updates about products and services you may be interested in."
                    fieldType="checkbox"
                    labelFor="checkboxNotify"
                    fieldId="checkboxNotify"
                    fieldName="checkbox"
                    disabled={loading}
                    value={checkbox}
                    onChange={onChange}
                  />
                </ValidationWrapper>
              </FieldItem>
            </FieldWrapper>
          </CommonInputWrapper>
          <SubmitWrapper>
            <ReCAPTCHA sitekey={process.env.GATSBY_SITE_KEY} ref={recaptcha} />
            <SubmitButtonWrapper>
              <ButtonAtom
                type="submit"
                buttonType="Submit Arrow Button"
                buttonCopy="Email me when back in stock"
                isLoading={loading}
                disabled={loading}
              />
            </SubmitButtonWrapper>
          </SubmitWrapper>
        </BodyWrapper>
      </Form>
    </Container>
  )
}

NotifyForm.propTypes = {}
